import { DividerHorizontal16 } from '@/page-src/product/components/divider-horizontal-16';
import { ProductPromotionCardListSectionContainer } from '@/page-src/product/components/promotion-card-list-section-container';
import { ProductDepositCalculationSection } from '@/page-src/product/pages/deposits/components/calculation-section';
import { ProductDepositDetailInfoSection } from '@/page-src/product/pages/deposits/components/detail-info-section';
import { ProductDepositInterestTableSection } from '@/page-src/product/pages/deposits/components/interest-rate-table-section';
import { ProductDepositMainInfoSection } from '@/page-src/product/pages/deposits/components/main-info-section';
import { ProductDepositMetaData } from '@/page-src/product/pages/deposits/components/meta-data';
import { ProductDepositRankSection } from '@/page-src/product/pages/deposits/components/rank-section';
import { SAVINGS_MAIN_COLOR } from '@/src/@domain/savings/constants';
import { SavingsProductGuidContextProvider } from '@/src/@domain/savings/hooks/use-savings-guid-context';
import {
  ResponsiveContainer,
  ResponsiveWrapper,
} from '@/src/@domain/shopping/components/section-common-container';
import { GlobalNavigationBar } from '@/src/components/global-navigation-bar';
import {
  trackClickPromotionProduct,
  trackClickPromotionProductDetailButton,
  trackExposePromotionProduct,
} from '@/src/events/trackers/product/deposits/product-guid';

export const ProductDepositsDetailMain = ({ productGuid }: { productGuid: string }) => (
  <>
    <SavingsProductGuidContextProvider productGuid={productGuid}>
      <GlobalNavigationBar />
      <ProductDepositMetaData />
      <ResponsiveContainer>
        <ResponsiveWrapper>
          <ProductDepositMainInfoSection />
          <ProductDepositCalculationSection />
          <DividerHorizontal16 />
          <ProductDepositRankSection />
          <ProductDepositDetailInfoSection />
          <ProductDepositInterestTableSection />
          <ProductPromotionCardListSectionContainer
            exposeProductTracker={trackExposePromotionProduct}
            clickProductTracker={trackClickPromotionProduct}
            clickButtonToListTracker={trackClickPromotionProductDetailButton}
            pointColor={SAVINGS_MAIN_COLOR.DEPOSIT}
          />
        </ResponsiveWrapper>
      </ResponsiveContainer>
    </SavingsProductGuidContextProvider>
  </>
);
